import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { storageApi } from '../api';

export default function StorageBar() {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryKey: ['storage-usage'],
    queryFn: storageApi.usage,
  });

  if (!data) return null;

  const usedMb = (data.bytesUsed / 1024 / 1024).toFixed(1);
  const allowedMb = Math.round(data.bytesAllowed / 1024 / 1024);
  const pct = Math.round(data.percentUsed);
  const warning = pct >= 80;

  return (
    <div className="bg-white rounded-lg shadow p-4 space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium text-slate-700">{t('storage.title')}</span>
        <span className={warning ? 'text-amber-700 font-medium' : 'text-slate-600'}>
          {usedMb} / {allowedMb} MB
        </span>
      </div>
      <div className="bg-slate-100 rounded-full h-2 overflow-hidden">
        <div
          className={`h-full transition-all ${
            pct >= 90 ? 'bg-red-500' : pct >= 80 ? 'bg-amber-500' : 'bg-slate-700'
          }`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-xs text-slate-500">
        {t('storage.mediaCount', { count: data.mediaCount })}
      </p>
    </div>
  );
}
